import { jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import { Paper } from "@mui/material";
function SectionPaper({
  children,
  sx
}) {
  const { gray } = useColors();
  return /* @__PURE__ */ jsx(
    Paper,
    {
      elevation: 0,
      sx: {
        borderRadius: 2,
        border: `1px solid ${gray[200]}`,
        overflow: "hidden",
        ...sx
      },
      children
    }
  );
}
export {
  SectionPaper
};
